import user from '@/router/middlewares/auth'
import Vue from 'vue'
import store from '@/store/store'
import Logger from '@/globals/Logger'

export default {
    guest (to, from, next) {
        next(!user.check())
    },

    checkAuth(to, from, next) {

        
        if(localStorage.getItem('access_token') !== null) {
            store.dispatch('getUserInfo').then((response) => {
                Logger('success', 'User Authenticated')
                next()
            }).catch((error) => {
                Logger('error', 'Token mismatch, user is unauthenticated.')
                localStorage.removeItem('access_token')
                next()
            });
        }
        next()

    },
    auth (to, from, next) {

        Logger('info', 'Authenticating user.')

        if(localStorage.getItem('access_token') == null) next({path:'/login'})

        if(store.state.auth.userInfo !== null) next()

        store.dispatch('getUserInfo').then((response) => {
            Logger('info', 'Authenticating user.', response)
            next();
        }).catch((error) => {
            Logger('error', 'Token mismatch, user is unauthenticated.')
            localStorage.removeItem('access_token')
            next({path:'/login'})
        });

    },

    checkPermissionsAdministrator (to, from, next) {

        var userInfo = store.state.auth.userInfo;

        if(userInfo !== null) {
            if(userInfo.role !== null && (userInfo.role == "administrator")) {
                next();
                return;
            }
        }

        next({path:'/401'})

    },

    checkPermissionsNetwork (to, from, next) {

        var userInfo = store.state.auth.userInfo;

        if(userInfo !== null) {
            if(userInfo.role !== null && (userInfo.role == "network")) {
                next();
                return;
            }
        }

        next({path:'/401'})

    },

    checkPermissionsChaser (to, from, next) {

        var userInfo = store.state.auth.userInfo;

        if(userInfo !== null) {
            if(userInfo.role !== null && (userInfo.role == "chaser" || userInfo.role == "administrator")) {
                next();
                return;
            }
        }

        next({path:'/401'})

    },


    preventLoginAccessIfLoggedIn(to, from, next) {

        if(localStorage.getItem('access_token') !== null && store.state.auth.userInfo !== null) {

            next({path:'/stringer/dashboard'})

            return;

        } else {

            if(localStorage.getItem('access_token') !== null) {

                store.dispatch('getUserInfo').then((response) => {
                    // console.log(response)
                    next();
                }).catch((error) => {
                    localStorage.removeItem('access_token')
                    next({path:'/login'})
                });

            }

        }

        next();

    },

    goToDashboard(to, from, next) {

        var permission = store.state.auth.userInfo.role;

        if(permission == 'chaser') {
            next({path:'/chaser/overview'})
        }

        if(permission == 'administrator') {
            next({path:'/admin/dashboard'})
        }

        if(permission == 'network') {
            next({path:'/client/overview'})
        }

        if(permission == 'user') {
            localStorage.removeItem('access_token')
            next({path:'/401'})
        }

        next();

    },


}
